import { Tabs } from '@cellebrite/saas-ui-common';
import React, { useContext } from 'react';
import { getPostReactionsTabsInfo } from '../../utils/utils';
import { useQuery } from 'react-query';
import api from '../../api/api';
import { GlobalContext } from '../../contexts/globalContext';
import PostReactionsSkeleton from './components/PostReactionsSkeleton/PostReactionsSkeleton';
import { Box, Typography } from '@mui/material';
import { EmptyState } from '../../images';
import { i18n } from '../../i18n/i18n';

interface ChipListProps {
    post: any;
    styles: any;
}

const PostReactions: React.FC<ChipListProps> = ({ post, styles }) => {
    const { reportData, workspacesData, casesData } = useContext(GlobalContext);
    const {
        data: postReactions,
        isLoading,
        isError,
    } = useQuery(
        [
            'postReactions',
            workspacesData.activeWorkspace?.id,
            casesData.activeCaseId,
            reportData.streamId,
            post.contentId,
            post.platform,
        ],
        ({ queryKey }) =>
            api.report.fetchPostReactions(
                queryKey[1] as number,
                queryKey[2] as string,
                queryKey[3] as string,
                queryKey[4],
                queryKey[5],
            ),
        {
            enabled: !!workspacesData.activeWorkspace?.id && !!casesData.activeCaseId && !!reportData.streamId,
            retry: false,
        },
    );
    return isError ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <EmptyState />
            <Typography variant="s24w700" className="color-bd" sx={{ mt: 3 }}>
                {i18n.translate("Can't Display Reactions")}
            </Typography>
            <Typography className="color-md">{i18n.translate('Try again in a few minutes.')}</Typography>
        </Box>
    ) : isLoading ? (
        <PostReactionsSkeleton />
    ) : (
        <Tabs
            styles={styles}
            tabs={getPostReactionsTabsInfo(
                post,
                postReactions,
                reportData.displayHighlights,
                reportData.currentHighlightsWatchlist,
            )}
        />
    );
};

export default PostReactions;
